import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const groupListState = atom({
  key: "groupListState",
  default: [],
  effects_UNSTABLE: [persistAtom], // 상태를 로컬 스토리지에 저장
});

export const comboListState = atom({
  key: "comboListState",
  default: [],
  effects_UNSTABLE: [persistAtom], // 상태를 로컬 스토리지에 저장
});
